<template>
  <div class="manage">

    <!------------------- 搜索 ------------------>
    <div class="manage-header">
      <el-form label-width="auto" :model="searchForm.formData"
               :inline="true" size="mini">
        <el-form-item>
          <el-date-picker
            v-model="searchForm.formData.dateRange"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-value="[new Date('2024-06-01'), new Date('2024-06-15')]">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search" size="mini">搜索 <i class="el-icon-search"/></el-button>
          <el-button type="danger" @click="reset" size="mini">重置 <i class="el-icon-refresh-left"/></el-button>
          <el-button type="warning" size="mini" @click="exportData" style="margin-left: 10px"
          >导出车数汇总表 <i class="el-icon-top"></i>
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-tag class="custom-large-tag">
            以下共计生产数量 {{ totalCount }} 车
          </el-tag>
        </el-form-item>
      </el-form>
    </div>


    <!------------------------ 数据表格 ----------------------->
    <div class="common-table">
      <el-table
        :data="table.tableData"
        height="85%"
        border
        stripe
        row-key="id"
        :header-cell-style="{background: '#eef1f6',color: '#606266',
        textAlign:'center',fontWeight:'bold',borderWidth:'3px'}"
      >
        <el-table-column prop="day" label="日期" min-width="30" align="center" />
        <el-table-column prop="code" label="车辆编号" min-width="20" align="center" >
          <template slot-scope="{ row }">
            <div style="min-height: 63px; display: flex; justify-content: center; align-items: center;">
              {{ row.code }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="卡机" min-width="30" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.type === 1">小卡机</span>
            <span v-else-if="row.type === 2">大卡机</span>
            <span v-else>未知</span>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="数量" min-width="30" align="center"/>
      </el-table>
      <el-pagination
        class="pager"
        layout="total,sizes,prev,pager,next,jumper"
        :page-size="table.pageConfig.size ? table.pageConfig.size : 10"
        :page-sizes="[5, 10, 15, 20]"
        :total="table.pageConfig.total"
        :current-page.sync="table.pageConfig.current"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

  </div>
</template>

<script>
import { getList, getExportApi } from '@/api/production'

export default {
  name: 'Total',
  data () {
    return {
      searchForm: {
        deptList: [],
        formData: {
          dateRange: [],
        }
      },
      dialogVisible: false,
      dialogImageUrl: '',
      totalCount: null,
      // time: '2023年10月11日 6点0分0秒 —— 2023年10月12日 6点0分0秒',
      table: {
        tableData: [],
        pageConfig: {
          total: 10, // 记录总数
          current: 1, // 起始页
          size: 10 // 每页展示的记录数
        }
      }
    }
  },
  methods: {
    formatDateToYYYYMMDDHHMMSS (date1) {
      const date = new Date(date1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
    },
    loading () {
      this.searchForm.formData.dateRange = [this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[0]), this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[1])]
      getList({
        current: this.table.pageConfig.current,
        size: this.table.pageConfig.size,
        startTime: this.searchForm.formData.dateRange[0],
        endTime: this.searchForm.formData.dateRange[1],
        isGroup: true,
        deptId: this.$store.state.staff.staff.deptId,
        type: 'day'
      }).then(response => {
        if (response.code === 200) {
          this.table.tableData = response.data.list
          this.table.pageConfig.total = response.data.total
          this.totalCount = response.data.totalCount
        } else {
          this.$message.error(response.message)
        }
      })
    },
    handleSizeChange (size) {
      this.table.pageConfig.size = size
      this.loading()
    },
    handleCurrentChange (current) {
      this.table.pageConfig.current = current
      this.loading()
    },
    search () {
      this.loading()
    },
    reset () {
      this.searchForm.formData = {}
      this.loading()
    },
    exportData () {
      this.searchForm.formData.dateRange = [this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[0]), this.formatDateToYYYYMMDDHHMMSS(this.searchForm.formData.dateRange[1])]
      window.location.href = getExportApi(this.searchForm.formData.dateRange[0], this.searchForm.formData.dateRange[1], null, true, this.$store.state.staff.staff.deptId, 'day');
    },
  },
  created () {
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(today.getMonth() - 1);
    this.searchForm.formData.dateRange = [this.formatDateToYYYYMMDDHHMMSS(new Date(oneMonthAgo)), this.formatDateToYYYYMMDDHHMMSS(new Date(today))]
    this.loading()
  }
}
</script>
<style>
.custom-large-tag {
  font-size: 25px; /* 设置标签的字体大小 */
  font-family: "方正粗黑宋简体",serif;
  padding: 7px 20px 21px 20px; /* 设置标签的内边距，以增加尺寸 */
}
</style>
